import { render } from "./LoadingSpinner.vue?vue&type=template&id=55bf3c7a&scoped=true"
import script from "./LoadingSpinner.vue?vue&type=script&lang=ts"
export * from "./LoadingSpinner.vue?vue&type=script&lang=ts"

import "./LoadingSpinner.vue?vue&type=style&index=0&id=55bf3c7a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-55bf3c7a"

export default script